var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComplatedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 112,
    viewBox: "0 0 97 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_2740_4677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3032 88.8885C48.9818 88.9956 48.7675 89.1027 48.4461 89.1027C48.1247 89.1027 47.9104 89.1027 47.589 88.8885L4.62695 72.175V103.566C4.62695 105.388 6.12687 106.888 7.94821 106.888H89.0511C90.8724 106.888 92.3723 105.388 92.3723 103.566V72.175L49.3032 88.8885ZM5.48405 67.5681L13.6265 70.7823V60.2828L5.48405 67.5681ZM61.1954 39.6053C59.9098 39.6053 58.9455 38.6411 58.9455 37.3554V20.2135H48.9818C48.9818 20.7492 49.0889 21.2849 49.0889 21.8205C49.0889 33.6056 39.4466 43.248 27.6615 43.248C24.2331 43.248 21.0189 42.3909 18.1262 40.9981V72.6036L48.3389 84.3887L78.2302 72.7107V39.6053H61.1954ZM66.7665 68.9609H29.8042C28.5186 68.9609 27.5543 67.8895 27.5543 66.711C27.5543 65.4254 28.5186 64.4612 29.8042 64.4612H66.7665C68.0522 64.4612 69.0164 65.5325 69.0164 66.711C69.1236 67.8895 68.0522 68.9609 66.7665 68.9609ZM66.7665 55.5688H29.8042C28.5186 55.5688 27.5543 54.4974 27.5543 53.3189C27.5543 52.0332 28.5186 51.069 29.8042 51.069H66.7665C68.0522 51.069 69.0164 52.0332 69.0164 53.3189C69.1236 54.6045 68.0522 55.5688 66.7665 55.5688ZM27.7686 5C18.4477 5 10.948 12.4996 10.948 21.8205C10.948 31.1415 18.4477 38.6411 27.7686 38.6411C36.9824 38.6411 44.5891 31.1415 44.5891 21.8205C44.5891 12.4996 36.9824 5 27.7686 5ZM35.4825 19.6778L27.34 27.8202C26.9115 28.2488 26.2687 28.4631 25.733 28.4631C25.0902 28.4631 24.5545 28.2488 24.1259 27.8202L19.6262 23.3205C18.7691 22.4634 18.7691 20.9634 19.6262 20.1063C20.4833 19.2493 21.9832 19.2493 22.8403 20.1063L25.6259 22.9991L32.1612 16.4637C33.0183 15.6066 34.5182 15.6066 35.3753 16.4637C36.3396 17.3208 36.3396 18.7136 35.4825 19.6778ZM63.5524 20.642V34.9984H78.016L63.5524 20.642ZM82.9443 60.0685V70.8894L91.4081 67.5681L82.9443 60.0685Z",
    fill: "url(#paint0_linear_2740_4677)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2740_4677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2337 85.9734C48.9412 86.0709 48.7462 86.1684 48.4537 86.1684C48.1612 86.1684 47.9662 86.1684 47.6737 85.9734L8.57617 70.7634V99.3309C8.57617 100.988 9.94117 102.353 11.5987 102.353H85.4062C87.0637 102.353 88.4287 100.988 88.4287 99.3309V70.7634L49.2337 85.9734ZM9.35617 66.5709L16.7662 69.4959V59.9409L9.35617 66.5709ZM60.0562 41.1234C58.8862 41.1234 58.0087 40.2459 58.0087 39.0759V23.4759H48.9412C48.9412 23.9634 49.0387 24.4509 49.0387 24.9384C49.0387 35.6634 40.2637 44.4384 29.5387 44.4384C26.4187 44.4384 23.4937 43.6584 20.8612 42.3909V71.1534L48.3562 81.8784L75.5587 71.2509V41.1234H60.0562ZM65.1262 67.8384H31.4887C30.3187 67.8384 29.4412 66.8634 29.4412 65.7909C29.4412 64.6209 30.3187 63.7434 31.4887 63.7434H65.1262C66.2962 63.7434 67.1737 64.7184 67.1737 65.7909C67.2712 66.8634 66.2962 67.8384 65.1262 67.8384ZM65.1262 55.6509H31.4887C30.3187 55.6509 29.4412 54.6759 29.4412 53.6034C29.4412 52.4334 30.3187 51.5559 31.4887 51.5559H65.1262C66.2962 51.5559 67.1737 52.4334 67.1737 53.6034C67.2712 54.7734 66.2962 55.6509 65.1262 55.6509ZM29.6362 9.63086C21.1537 9.63086 14.3287 16.4559 14.3287 24.9384C14.3287 33.4209 21.1537 40.2459 29.6362 40.2459C38.0212 40.2459 44.9437 33.4209 44.9437 24.9384C44.9437 16.4559 38.0212 9.63086 29.6362 9.63086ZM36.6562 22.9884L29.2462 30.3984C28.8562 30.7884 28.2712 30.9834 27.7837 30.9834C27.1987 30.9834 26.7112 30.7884 26.3212 30.3984L22.2262 26.3034C21.4462 25.5234 21.4462 24.1584 22.2262 23.3784C23.0062 22.5984 24.3712 22.5984 25.1512 23.3784L27.6862 26.0109L33.6337 20.0634C34.4137 19.2834 35.7787 19.2834 36.5587 20.0634C37.4362 20.8434 37.4362 22.1109 36.6562 22.9884ZM62.2012 23.8659V36.9309H75.3637L62.2012 23.8659ZM79.8487 59.7459V69.5934L87.5512 66.5709L79.8487 59.7459Z",
    fill: "url(#paint1_linear_2740_4677)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2740_4677",
    x: 0.336953,
    y: 0.71,
    width: 96.3251,
    height: 110.468,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.145,
    result: "effect1_foregroundBlur_2740_4677"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2740_4677",
    x: 8.57617,
    y: 9.63086,
    width: 79.8525,
    height: 96.6227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.68125 0 0 0 0 0.971494 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2740_4677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2740_4677",
    x1: 3.41945,
    y1: 5.00002,
    x2: 94.7869,
    y2: 7.90363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#579DF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DFE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2740_4677",
    x1: 7.47728,
    y1: 9.63088,
    x2: 90.626,
    y2: 12.2733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#579DF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DFE1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplatedIcon);
export default __webpack_public_path__ + "static/media/complated-icon.b881078b8a0990d878e96455c6caf316.svg";
export { ForwardRef as ReactComponent };